// src/pages/AddPackaging.js
import React, { useState, useEffect } from "react";
import { useAuthCheck } from "../components/Auth";
import { api } from "../components/Api";
import { useNavigate } from "react-router-dom";

export default function AddPackaging() {
    const [formData, setFormData] = useState({
        packaging_name: "",
        packaging_dimension: "",
        packaging_weight: "",
        packaging_quantity: 0, // valeur par défaut
        packaging_link: "",
    });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            await api.post("/packaging", formData);
            navigate("/packaging-list");
        } catch (err) {
            console.error(err);
            if (err.response?.status === 422) {
                setError("Certains champs sont invalides ou déjà utilisés.");
            } else {
                setError("Erreur lors de l'ajout du packaging.");
            }
        } finally {
            setLoading(false);
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6 max-w-lg">
            <h1 className="text-2xl font-bold mb-4 dark:text-white">Ajouter un packaging</h1>

            <form onSubmit={handleSubmit} className="space-y-4">
                {/* Nom */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Nom du packaging
                    </label>
                    <input
                        type="text"
                        name="packaging_name"
                        value={formData.packaging_name}
                        onChange={handleChange}
                        required
                        className="w-full border rounded px-3 py-2 dark:bg-gray-700 bg-white"
                    />
                </div>

                {/* Dimension */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Dimensions
                    </label>
                    <input
                        type="text"
                        name="packaging_dimension"
                        value={formData.packaging_dimension}
                        onChange={handleChange}
                        placeholder="Ex: 10x15x3 "
                        className="w-full border rounded px-3 py-2 dark:bg-gray-700 bg-white"
                    />
                </div>

                {/* Poids */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Poids (en grammes)
                    </label>
                    <input
                        type="number"
                        name="packaging_weight"
                        value={formData.packaging_weight}
                        onChange={handleChange}
                        placeholder=""
                        className="w-full border rounded px-3 py-2 dark:bg-gray-700 bg-white"
                    />
                </div>

                {/* Lien */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Lien du fournisseur
                    </label>
                    <input
                        type="url"
                        name="packaging_link"
                        value={formData.packaging_link}
                        onChange={handleChange}
                        placeholder="https://..."
                        className="w-full border rounded px-3 py-2 dark:bg-gray-700 bg-white"
                    />
                </div>

                {/* Erreur */}
                {error && <p className="text-red-500 text-sm">{error}</p>}

                {/* Bouton */}
                <button
                    type="submit"
                    disabled={loading}
                    className="bg-blue-400 hover:bg-blue-500 text-white font-semibold rounded px-4 py-2 disabled:opacity-50"
                >
                    {loading ? "Enregistrement..." : "Enregistrer"}
                </button>
            </form>
        </div>
    );
}
